import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RichTextComponent } from '@domgen/dgx-fe-components/content';
import { TestHookDirective } from '@domgen/dgx-fe-components/general';
import { IconComponent } from '@domgen/dgx-fe-components/icon';
import { provideTranslationDictionaryMapping } from '@domgen/dgx-fe-i18n';
import { translation } from './i18n/translation.constant';
import { RegistrationTermsAndConditionsTestHooks } from './test/registration-terms-and-conditions-test-hooks.enum';

@Component({
  standalone: true,
  selector: 'us-registration-terms-and-conditions',
  templateUrl: './registration-terms-and-conditions.component.html',
  styleUrls: ['./registration-terms-and-conditions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, NgIf, TestHookDirective, RichTextComponent],
  providers: [provideTranslationDictionaryMapping(translation)],
})
export class RegistrationTermsAndConditionsComponent {
  @Input() termsAndConditions?: string;
  testHooks = RegistrationTermsAndConditionsTestHooks;
}
